import React from 'react';
import { Page, PageHeader, PageBody } from "../base/Page";
import { Button, Row, Col, Panel, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import API from "../base/API";
import { browserHistory } from "react-router";
import Auth from "../auth/Auth";
import Switch from 'react-bootstrap-switch';
import { translate } from '../base/Translation';

export default class ErrorResultEdit extends Auth {

    constructor(props) {
        super(props);

        this.api = new API({
            get_result: "/error_result/fetch/:result",
            get_test: "/test/fetch/:test",
            get_error: "/error/fetch/:error",
            get_protocol: "/protocol/fetch/:protocol",
            save_result: "/error_result/save/:result",
        });

        this.state = {
            test: null,
            error: null,
            protocol: null,
            result: null
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        this.api.request({
            route: "get_result",
            params: { result: this.props.params.result_ID },
            success: (response) => {
                this.setState({
                    result: response.result,
                    test: response.test,
                    error: response.error,
                    protocol: response.protocol
                });
            }
        });
    }

    onSave(evt) {
        this.api.request({
            route: "save_result",
            params: { "result": this.props.params.result_ID },
            data: this.state.result,
            created: (response) => {
                browserHistory.push("/tests/" + this.state.test.id + "#test_errordb");
            }
        });
    }

    onChange(evt) {
        let result = this.state.result;
        result[evt.target.name] = evt.target.value;
        this.setState({ result });
    }

    renderOptions(data) {
        let options = data.map(function (item) {
            return (
                <option value={item.id} key={item.id}>{typeof item.name !== "undefined" ? item.name : item.email}</option>
            )
        });

        return (options);
    }

    handleSwitch(elem, state) {
        let result = this.state.result;
        result[elem.props.name] = state;
        this.setState({ result });
    }

    render() {

        if (this.state.result === null || this.state.error === null || this.state.protocol === null || this.state.test === null) {
            return (
                <Page>
                    <PageHeader>{translate("Prosím počkajte")}</PageHeader>
                    <PageBody>{translate("Obsah sa načítava")}</PageBody>
                </Page>
            );
        }

        let result = this.state.result;

        if (result.state_before === "") {
            result.state_before = this.state.error.state_before;
        }

        if (result.required_state === "") {
            result.required_state = this.state.error.required_state;
        }

        if (result !== this.state.result) {
            this.setState({ result });
        }

        return (
            <Page>
                <PageHeader title={translate("Upraviť chybu")} />
                <PageBody>
                    <Row>
                        <Col lg={12}>
                            <Panel header={this.state.error.group}>
                                <Row>
                                    <Col lg={6}>
                                        <FormGroup>
                                            <ControlLabel>{translate("Predmet kontroly")}</ControlLabel>
                                            <FormControl disabled defaultValue={this.state.error.component + " (" + this.state.error.code + ")"} />
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>{translate("Požadovaný stav")}</ControlLabel>
                                            <FormControl name="required_state" defaultValue={this.state.result.required_state} onChange={this.onChange.bind(this)} />
                                        </FormGroup>

                                        <Row className="row">
                                            <Col md={9} sm={12}>
                                                <FormGroup>
                                                    <ControlLabel>{translate("Stav pred testom")}</ControlLabel>
                                                    <FormControl value={this.state.result.state_before} name="state_before" onChange={this.onChange.bind(this)} />
                                                </FormGroup>
                                            </Col>
                                            <Col md={3} sm={12}>
                                                <FormGroup>
                                                    <ControlLabel>{translate("Simulované")}</ControlLabel>
                                                    <Switch value={this.state.result.simulated} onText={translate("Áno")} offText={translate("Nie")} onChange={(el, state) => this.handleSwitch(el, state)} name='simulated' />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={9} sm={12}>
                                                <FormGroup>
                                                    <ControlLabel>{translate("Stav po teste")}</ControlLabel>
                                                    <FormControl value={this.state.result.state_after ? this.state.result.state_after : ""} name="state_after" onChange={this.onChange.bind(this)} />
                                                    <div className="input_note">{translate("Požadovaný stav")}
                                                <span className="highlight clickable" onClick={() => {
                                                            let result = this.state.result;
                                                            result.state_after = this.state.result.required_state;
                                                            this.setState({ result });
                                                        }}>{this.state.result.required_state}</span>
                                                    </div>
                                                </FormGroup>
                                            </Col>
                                            <Col md={3} sm={12}>
                                                <FormGroup>
                                                    <ControlLabel>{translate("Vyhovel")}</ControlLabel>
                                                    <Switch value={this.state.result.successful} onText={translate("Áno")} offText={translate("Nie")} onChange={(el, state) => this.handleSwitch(el, state)} name='successful' />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <FormGroup>
                                            <ControlLabel>{translate("Poznámka")}</ControlLabel>
                                            <FormControl componentClass="textarea" value={this.state.result.note} name="note" onChange={this.onChange.bind(this)} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Panel>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <FormGroup>
                                <Button bsStyle="success" onClick={this.onSave.bind(this)}>{translate("Uložiť")}</Button>
                            </FormGroup>
                        </Col>
                    </Row>
                </PageBody>
            </Page>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/error/ErrorResultEdit.js